import React from 'react';

import { useEffect, useState } from 'react';

import useWindowWidth from '../../hooks/useWindowWidth';

import { useNavigate } from 'react-router-dom';

import { Button } from '../../components/Button';
import { Footer } from '../../components/Footer';
import { Header } from '../../components/Header';
import { HeaderPage } from '../../components/HeaderPage';
import { InfoCircle } from '../../components/InfoCircle';
import { Input } from '../../components/Input';
import { Pagination } from '../../components/Pagination';
import { Tag } from '../../components/Tag';
import './style.css';

import ResourceStore from '../../stores/ResourceStore';

import PreviewBox from '../../components/PreviewBox/PreviewBox';

import ScrollToHashElement from '@cascadia-code/scroll-to-hash-element';

import { NavMenuButton } from '../../icons/NavMenuButton';

export const DirectoryDesktop = ({ shareFeedbackEmailAddress, showDates }) => {
    const navigate = useNavigate();

    const resourceStore = ResourceStore((state) => state);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(9);
    const [lastPage, setLastPage] = useState(1);
    const [totalResults, setTotalResults] = useState(0);
	const [open, setOpen] = useState(false);

	const vw = useWindowWidth();	
	const isViewingWithMobile = vw < 576;

    const success = (res) => {
        setLastPage(res.lastPage);
        setTotalResults(res.totalResults);
    };

    useEffect(() => {
        resourceStore.search(
            resourceStore.filterSettings,
            resourceStore.fullTextSearchString,
            currentPage,
            pageSize,
            success,
        );

        // If the front-end cache of the fitersettings has been initialized
        // or has expired or for some reason isn't available, then fetch it
        if (0 === resourceStore.filterSettings.length) {
            resourceStore.loadSearchOptions();
        }

        // The [] is for specifying dependencies, and for componentDidMount lifecycle equivalent
        // we need to specify no dependencies.
        // See https://stackoverflow.com/questions/53945763/componentdidmount-equivalent-on-a-react-function-hooks-component#
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    var cards = null;

    if (null != resourceStore.portalResources) {
        cards = resourceStore.portalResources.map((element, i) => {
            return <PreviewBox element={element} i={i} showDate={showDates} />;
        });
    }

    const filterSettings = resourceStore.filterSettings;

    const handlePageChange = (page) => {
        // change page on click
        var newCurrentPage = page;

        if (newCurrentPage >= 1 && newCurrentPage <= lastPage) {
            setCurrentPage(newCurrentPage);
            resourceStore.search(
                resourceStore.filterSettings,
                resourceStore.fullTextSearchString,
                newCurrentPage,
                pageSize,
                success,
            );
        }
    };

    const handlePageSizeChange = (e) => {
        var newPageSize = Number(e.target.value);
        setPageSize(newPageSize);
        setCurrentPage(1);
        resourceStore.search(
            resourceStore.filterSettings,
            resourceStore.fullTextSearchString,
            currentPage,
            newPageSize,
            success,
        );
    };

    function buildSearchCriteriaControl(area) {
        /* when a search item is collapsed */

        if (area.isCollapsed) {
            return (
                <div
                    key={'search-control-area-' + area.label}
                    className="category-list"
                >
                    <div className="list-item">
                        <div className="title-3">
                            <div className="title-4">
                                {area.userFriendlyLabel}
                            </div>
                            <img
                                className="accordion-icon"
                                alt="Accordion icon"
                                src="/img/accordion-icon-28.svg"
                                onClick={() => {
                                    resourceStore.toggleAreaCollapsedState(
                                        area.label,
                                    );
                                }}
                            />
                        </div>
                    </div>
                </div>
            );
        } else {
            /* when a search item is expanded */
            return (
                <div
                    key={'search-control-area-' + area.label}
                    className="list-item-wrapper"
                >
                    <div className="list-item-2">
                        <div className="title-5">
                            <div className="title-6">
                                {area.userFriendlyLabel}
                            </div>
                            <img
                                className="accordion-icon"
                                alt="Accordion icon"
                                src="/img/accordion-icon-29.svg"
                                onClick={() => {
                                    resourceStore.toggleAreaCollapsedState(
                                        area.label,
                                    );
                                }}
                            />
                        </div>

                        <div className="nav-vertical">
                            {area.subAreas.map((subArea, j) => {
                                const activityState = subArea.isActive
                                    ? 'active'
                                    : 'default';

                                return (
                                    <Tag
                                        key={'tag-' + j}
                                        className="tag-instance"
                                        size="default"
                                        stateProp={activityState}
                                        style="default"
                                        text={subArea.label}
                                        onClick={() => {
                                            resourceStore.toggleFilterParamSetting(
                                                area.label,
                                                subArea.label,
                                            );
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="homepage-desktop directory-desktop">
			<ScrollToHashElement />

            <Header
                className="design-component-instance-node-4"
                style="desktop"
                shareFeedbackEmailAddress={shareFeedbackEmailAddress}
                logoDimensions={{
                    height: 64 * 1.8 + 'px',
                    width: 104 * 1.8 + 'px',
                }}
            />
            <HeaderPage
                align="left"
                background="default"
                breadcrumbLinkText="Materialien"
                breakpoint="desktop"
                className="header-page-3"
                text={<>Finden Sie heraus, was die Forschung dazu sagt!</>}
                title="Wie können digitale Medien im Unterricht genutzt werden?"
            />
            <div className="section-3">
                <div className="content-7">
					
					{ buildFilterPanel(isViewingWithMobile, open) }
                    
					<div className="results-container" id="results-container">
                        <div className="resources-grid">
                            {totalResults === 0 ? (
                                <div className={isViewingWithMobile ? "no-results-messege-mobile" : "no-results-messege"}>
                                    Unfortunately, no results containing your
                                    search criteria were found.
                                </div>
                            ) : (
                                cards
                            )}
                        </div>

                        {totalResults > 0 && (
                            <div className="pagination-container">
                                <div className="pagination-wrapper">
                                    <div className="divider-wrapper">
                                        <img
                                            className="simple-line"
                                            alt="Simple line"
                                            src="/img/simple-line-1.svg"
                                        />
                                    </div>
                                </div>
                                <div className="div-wrapper-2">
                                    <div className="frame-pagination-center">
                                        <Pagination
                                            currentPage={currentPage}
                                            lastPage={lastPage}
                                            pageSize={pageSize}
                                            totalResults={totalResults}
                                            handlePageChange={handlePageChange}
                                            handlePageSize={
                                                handlePageSizeChange
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
            <Footer
                className="design-component-instance-node-4"
                logosPartnersGroupLogoPartnerBundesministerium="/img/BMBFSFJ_gefoerdert_vom_deutsch_Web_c.svg"
                property1="desktop"
            />
        </div>
    );

	function buildFilterPanel(isViewingWithMobile, isFilterPanelOpen){
		if(! isViewingWithMobile){
			return buildExpandedFilterPanel(isViewingWithMobile);	
		}
		else {
			return isFilterPanelOpen ? buildExpandedFilterPanel(isViewingWithMobile) : buildCollapsedFilterPanel(); 
		}
	}

    function buildCollapsedFilterPanel(){
		return <div className="search-filter">
                <div className="frame-18">
                    <div className="heading">
						<div className="text-wrapper-15">Filter</div>
                        <div className="frame-19" />
						<div className="frame-right">
		                    <button
		                        className="header-hamburger"
		                        type="button"
		                        onClick={() => setOpen((p) => !p)}
		                    >
		                        <NavMenuButton open={open} />
		                    </button>
		                </div>
                    </div>

                </div>

            </div>;
	}
	
	function buildExpandedFilterPanel(isViewingWithMobile){
		return <>
			<div className="search-filter">
                        <div className="frame-18">
                            <div className="heading">
								<div className="text-wrapper-15">Filter</div>
                                <div className="frame-19" />
								<div className="frame-right">
				                    <button
				                        className="header-hamburger"
				                        type="button"
				                        onClick={() => setOpen((p) => !p)}
				                    >
				                        {isViewingWithMobile ?  <NavMenuButton open={open} /> : null }
				                    </button>
				                </div>
                            </div>

                            <Input
                                className="design-component-instance-node-4"
                                function1="input"
                                iconIcon={<InfoCircle />}
                                stateProp="default"
                                text={resourceStore.fullTextSearchString}
                                onChange={(e) => {
                                    let searchString = e.target.value;
                                    resourceStore.setFullTextSearchString(
                                        searchString,
                                    );
                                }}
                            />

                            <div className="list-group">
                                {filterSettings.map((area, i) => {
                                    return buildSearchCriteriaControl(area);
                                })}
                            </div>

                            <div className="frame-20">
                                <Button
                                    className="button-4"
                                    status="default"
                                    style="secondary"
                                    textLink="Anwenden"
                                    onClick={() => {

										setOpen(false);
	
                                        resourceStore.search(
                                            resourceStore.filterSettings,
                                            resourceStore.fullTextSearchString,
                                            currentPage,
                                            pageSize,
                                            success,
                                        );

										navigate('/directory#results-container');

                                    }}
                                />

                                <Button
                                    className="button-4"
                                    status="default"
                                    style="secondary"
                                    textLink="Zurücksetzen"
                                    onClick={() => {
	
										setOpen(false);
	
                                        // This should also refresh the search page but currently a separate 'Apply' click is needed
                                        setCurrentPage(1);
                                        resourceStore.resetSearchCriteriaAndRefreshPage(
                                            pageSize,
                                            success,
                                        );
                                    }}
                                />
                            </div>
                        </div>

                        <div className="frame-21">
                            <Button
                                className="filter-button"
                                status="default"
                                style="secondary"
                                textLink="FAQ"
                                onClick={() => {
                                    navigate('/faq');
                                }}
                            />
                            {/*<Button className="filter-button" status="default" style="secondary" textLink="Glossary" />*/}
                            <Button
                                className="filter-button"
                                status="default"
                                style="secondary"
                                textLink="Kontakt &amp; Support"
                                onClick={(e) => {
                                    window.location =
                                        'mailto:' + shareFeedbackEmailAddress;
                                }}
                            />
                        </div>
                    </div>
                    
</>;
	}
};
